
let ga;
let ts;

const countCheck = function(e){
    ts.style.display = 'none';
    if(document.getElementById('giftaid').checked) {
        ts.style.display = 'block';
    }
};

let hidePersonalationID = function() {
    let regex = /(PersonalisationID:)\s+([\d\w]{13})/g;
    document.querySelectorAll('.cart-items__name').forEach(function(item) {
       item.innerHTML = item.innerHTML.replace(regex, '<span class="personalisation-id">$1 $2</span> <a href="javascript:void(0);" class="pwEditOrderLink" onclick="editOrder(\'$2\');">Edit Personalisation</a>');
    });
    document.querySelectorAll('.ajaxcart__product-meta').forEach(function(item) {
        item.innerHTML = item.innerHTML.replace(regex, '<span class="personalisation-id">$1 $2</span>');
    });
};

let pw_post_replace_cart_img = function() {
    hidePersonalationID();
};

window.addEventListener('load', function () {

    ga = document.getElementById('gift-aid-apply');
    ts = document.getElementById('taxstatement');

    if(ga) {
        countCheck();
        ga.querySelectorAll('#gift-aid-apply input').forEach(function (elm) {
            elm.addEventListener('click', countCheck);
        });
    }

    $(document.body).on('afterGetCart.ajaxCart', function(e,cart) {
        let cartForm = $('.cart.ajaxcart');
        let button = $('.cart__checkout', cartForm);

        button.unbind('click').on('click', function(e) {
            e.preventDefault();
            window.location = '/cart';
        });
        hidePersonalationID();
    });


});

 $(document).ready(function() {
   
$('#agree').on("change", function()
{
    ToggleAgree(false);
});

setTimeout(function(){
    ToggleAgree(true);
}, 500);

function ToggleAgree(init)
{
    
  console.log("ToggleAgree running", init);
  if ($('#agree').is(':checked')) {
        $(".overlay").hide();

 

        if (!init)
            $(".termswarning").hide();
      }
      else {
        $(".overlay").show();

 

        if (!init)
            $(".termswarning").show();
      }
}

     $('.overlay').on('click', function(e) {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {

        $(".termswarning").css('display','block');
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
   
   $("#add-donation-button").on("click", function(e)
{
e.preventDefault();

$("#donation-popup").css('display','flex');
});
   
      $("#add-donation-button-cart").on("click", function(e)
{
e.preventDefault();

        $("#donation-popup").css('display','flex');
});
   
         $("#add-donation-mobile-button").on("click", function(e)
{
e.preventDefault();

        $("#donation-popup").css('display','flex');
});
   


$(".closePopup").on("click", function(e)
{
e.preventDefault();
$("#donation-popup").hide();
});
  });

